import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoadingService } from '../../../core/services/loading.service';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit, OnDestroy {
  
  public loading$: Observable<boolean>;
  public loadingMessage$: Observable<string>;
  private destroy$ = new Subject<void>();

  constructor(private loadingService: LoadingService) {
    this.loading$ = this.loadingService.loading$;
    this.loadingMessage$ = this.loadingService.loadingMessage$;
  }

  ngOnInit(): void {
    // Sottoscrizione per eventuali operazioni aggiuntive
    this.loading$
      .pipe(takeUntil(this.destroy$))
      .subscribe(isLoading => {
        // Gestisci eventuali side effects del loading (es. scroll block)
        if (isLoading) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = 'auto';
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    // Ripristina lo scroll in caso di distruzione del componente
    document.body.style.overflow = 'auto';
  }
}
